import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", {
      class: _normalizeClass(_ctx.isMobile?'mx-2':'mx-8')
    }, _toDisplayString(_ctx.title.plural), 3),
    _createVNode(_component_v_row, {
      class: _normalizeClass(["align-center", _ctx.isMobile?'':'mx-3'])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "2",
          class: "d-flex align-center pb-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tooltip, { location: "top" }, {
              activator: _withCtx(({ props }) => [
                (_ctx.currentView === 'table' || _ctx.currentView === 'calendar' )
                  ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
                      variant: "plain",
                      class: "square-btn",
                      icon: "",
                      onClick: _ctx.openFilters
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createTextVNode("mdi mdi-filter")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1040, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _cache[4] || (_cache[4] = _createTextVNode(" Filtros "))
              ]),
              _: 1
            }),
            _createVNode(_component_v_tooltip, { location: "top" }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, {
                  variant: "plain",
                  class: "square-btn",
                  icon: "",
                  onClick: _ctx.openPreferences
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("mdi mdi-cog")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1040, ["onClick"])
              ]),
              default: _withCtx(() => [
                _cache[6] || (_cache[6] = _createTextVNode(" Preferencias "))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.currentView == 'grid' || _ctx.currentView == 'card')
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              cols: "5",
              class: "d-flex align-center pb-0 px-6"
            }, {
              default: _withCtx(() => [
                _cache[9] || (_cache[9] = _createTextVNode(" Ordenar por: ")),
                _createVNode(_component_v_autocomplete, {
                  modelValue: _ctx.sortBy,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sortBy) = $event)),
                  items: _ctx.sortableHeaders,
                  "item-title": "title",
                  "item-value": "value",
                  density: "compact",
                  style: {"max-width":"200px"},
                  class: "mx-4",
                  "hide-details": "",
                  variant: "outlined"
                }, null, 8, ["modelValue", "items"]),
                _createVNode(_component_v_btn, {
                  variant: "plain",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.direction === 'asc' ? (_ctx.direction = 'desc') : (_ctx.direction = 'asc'))),
                  density: "compact",
                  style: {"min-width":"0px"},
                  class: "px-0"
                }, {
                  default: _withCtx(() => [
                    (_ctx.direction === 'asc')
                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createTextVNode("mdi-arrow-up")
                          ])),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createTextVNode("mdi-arrow-down")
                          ])),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_col, {
          cols: "5",
          class: "ml-auto d-flex justify-end pb-0"
        }, {
          default: _withCtx(() => [
            (!_ctx.isMobile)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  class: "mr-6 mt-2",
                  onClick: _ctx.openCreateForm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Crear " + _toDisplayString(_ctx.title.singular), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.filteredViewModes.length>1)
              ? (_openBlock(), _createBlock(_component_v_btn_toggle, {
                  key: 1,
                  mandatory: "",
                  modelValue: _ctx.currentView,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentView) = $event)),
                  color: "primary",
                  variant: "text"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredViewModes, (mode) => {
                      return (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: mode.value,
                        location: "top"
                      }, {
                        activator: _withCtx(({ props: tooltipProps }) => [
                          _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, tooltipProps, {
                            class: "square-btn ma-2",
                            icon: "",
                            value: mode.value
                          }), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(mode.icon), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1040, ["value"])
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString(mode.label), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.isMobile)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              icon: "",
              class: "fab-btn",
              onClick: _ctx.openCreateForm
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { color: "white" }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode("mdi-plus")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}